export function PencilIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      aria-label="Pencil Icon"
      role="img"
    >
      <path
        d="M10.6464 3.35355L12.6464 5.35355M3 13L3.5 10.5C3.53 10.36 3.6 10.23 3.71 10.12L10.65 3.18C10.84 2.99 11.16 2.99 11.35 3.18L12.82 4.65C13.01 4.84 13.01 5.16 12.82 5.35L5.88 12.29C5.77 12.4 5.64 12.47 5.5 12.5L3 13Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
